import { Col, Row } from "antd";
import "../../pages/styles/HomeView.scss"

export default function CardsWhiteHome({
    onClick,
    image,
    title,
    subtitle,
}) {
    return (
        <Row className="cardsWhiteContainer" onClick={onClick}>
            <Col className="column-leading">
                <img className="img-leading" src={image} />
            </Col>
            <Col className="column-content">
                <h2 style={{ color: "#7B7B7B" }}>{title}</h2>
                <p style={{ color: "#7B7B7B", fontSize: "12px" }}>{subtitle}</p>
            </Col>
        </Row>
    );
}